// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"4f84e8e6","780":"69fe8646"}[chunkId] + ".chunk.js";
};